<div class="container">
    <div class="row justify-content-center">
        <div class="col-12 col-sm-6 col-lg-4">
            <h1 class="title text-center">{{ 'message.access-denied' | translate }}</h1>
            <p class="message text-center">{{ message | translate }}</p>
        </div>
    </div>
</div>
